(function () {
  var rules = window.upsellRules || [];
  if (!rules.length) return;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsStr = parts[1] ? (decimal + parts[1]) : '';
      return dollars + centsStr;
    }
    var match = formatString.match(placeholderRegex);
    var value = '';
    if (match) {
      switch (match[1]) {
        case 'amount': value = formatWithDelimiters(cents, 2); break;
        case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
        default: value = formatWithDelimiters(cents, 2);
      }
    }
    return formatString.replace(placeholderRegex, value);
  }

  function renderCarousel(products) {
    var $upsell = $('#cart-upsell');
    var $carousel = $('#cart-upsell-carousel');

    $carousel.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded owl-drag');
    $carousel.empty();

    if (!products || !products.length) {
      $upsell.hide();
      return;
    }

    products.forEach(function (p) {
      $carousel.append(
        '<div class="cart-upsell__item">' +
          '<a href="' + p.url + '">' +
            '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">' +
            '<p class="cart-upsell__title">' + p.title + '</p>' +
            '<p class="cart-upsell__price">' + p.price + '</p>' +
          '</a>' +
        '</div>'
      );
    });

    $carousel.addClass('owl-carousel owl-theme').owlCarousel({
      items: 2,
      margin: 10,
      nav: true,
      dots: false,
      navText: ['&#8249;', '&#8250;']
    });

    $upsell.show();
  }

  // excludeIds is an array of product ID strings already in the cart
  function mapProducts(products, excludeIds) {
    return (products || [])
      .filter(function (p) { return excludeIds.indexOf(String(p.id)) === -1; })
      .slice(0, 10)
      .map(function (p) {
        return {
          title: p.title,
          url: '/products/' + p.handle,
          price: formatMoney(p.variants[0].price, theme.moneyFormat),
          image: p.images.length ? p.images[0].src : ''
        };
      });
  }

  function applyRule(rule, productId, cartProductIds) {
    if (rule.upsell_source_type === 'products' && rule.upsell_products && rule.upsell_products.length) {
      var filtered = rule.upsell_products.filter(function (p) {
        return cartProductIds.indexOf(String(p.id)) === -1;
      });
      renderCarousel(filtered);

    } else if (rule.upsell_source_type === 'collection' && rule.upsell_collection_handle) {
      $.getJSON('/collections/' + rule.upsell_collection_handle + '/products.json?limit=10', function (data) {
        renderCarousel(mapProducts(data.products, cartProductIds));
      });

    } else if (rule.upsell_source_type === 'same_collection') {
      if (rule.trigger_type === 'collection' && rule.trigger_collection_handle) {
        $.getJSON('/collections/' + rule.trigger_collection_handle + '/products.json?limit=50', function (data) {
          renderCarousel(mapProducts(data.products, cartProductIds));
        });
      } else {
        $.getJSON('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related', function (data) {
          renderCarousel(mapProducts(data.products, cartProductIds));
        });
      }

    } else {
      $('#cart-upsell').hide();
    }
  }

  function checkRules(productId, rules, index, cartProductIds) {
    if (index >= rules.length) {
      $('#cart-upsell').hide();
      return;
    }

    var rule = rules[index];

    if (rule.trigger_type === 'product') {
      if (String(rule.trigger_product_id) === String(productId)) {
        applyRule(rule, productId, cartProductIds);
      } else {
        checkRules(productId, rules, index + 1, cartProductIds);
      }
    } else if (rule.trigger_type === 'collection' && rule.trigger_collection_handle) {
      $.getJSON('/collections/' + rule.trigger_collection_handle + '/products.json?limit=250', function (data) {
        var ids = (data.products || []).map(function (p) { return String(p.id); });
        var inCollection = ids.indexOf(String(productId)) !== -1;
        if (inCollection) {
          applyRule(rule, productId, cartProductIds);
        } else {
          checkRules(productId, rules, index + 1, cartProductIds);
        }
      }).fail(function () {
        checkRules(productId, rules, index + 1, cartProductIds);
      });
    } else {
      checkRules(productId, rules, index + 1, cartProductIds);
    }
  }

  // Fetch cart, find the highest-value item, run rules against it.
  // cartProductIds are excluded from the upsell display.
  function refreshUpsell() {
    $.getJSON('/cart.js', function (cart) {
      if (!cart.items || !cart.items.length) {
        $('#cart-upsell').hide();
        return;
      }

      var mostValuable = cart.items.reduce(function (best, item) {
        return item.line_price > best.line_price ? item : best;
      }, cart.items[0]);

      var cartProductIds = cart.items.map(function (item) { return String(item.product_id); });
      checkRules(String(mostValuable.product_id), rules, 0, cartProductIds);
    });
  }

  // Re-populate on every page load so the carousel persists across navigation
  $(function () { refreshUpsell(); });

  // Re-evaluate whenever something is added to cart
  $(document).on('variant_add_to_cart_successful', function () {
    refreshUpsell();
  });
})();
